import moment from 'moment';

export const generateRequestsByDate = (request, map) => {
  const date = moment(request.createDateTime);
  const id = moment.isMoment(date) ? date.format('DD.MM.YYYY') : undefined;

  if (!id) return;

  const entity = map.get(id) || {
    name: id,
    value: 0,
    day: date.format('dd'),
  };

  entity.value += 1;
  map.set(id, entity);
};
